
import "./tuileDebugDeclencheur.scss";

import { Component, MouseEvent } from "react";
import { CodeDeplacement, CodeDeplacementListe } from '../../../interfaces/ILabyData';
import GameplayManager from "../GameplayManager";
import clsx from 'clsx';
import { getPositionFromIndex, objPosition } from '../GameplayUtils';

interface ITuileDebugDeclencheurProps{    
    gpl_manager:GameplayManager; 
    index:number;     
    codeDeplacement:CodeDeplacement;
}
type TTuileDebugDeclencheurState = {
    codeDeplacement:CodeDeplacement;
}

class TuileDebugDeclencheur extends Component<ITuileDebugDeclencheurProps,TTuileDebugDeclencheurState> {

  gpl_manager:GameplayManager;
  index:number;    
  position:objPosition = {colonne:0, ligne:"X"};

  state:TTuileDebugDeclencheurState = this.getInitialState();
  constructor(props:any){
    super(props);
    this.gpl_manager = props.gpl_manager;
    this.index = props.index;
    this.position = getPositionFromIndex(this.index);
  }
  getInitialState():TTuileDebugDeclencheurState{
    return{
        codeDeplacement:"?"
    }
  }


  componentDidMount(){      
    this.setState({codeDeplacement:this.props.codeDeplacement})
  }

  getClassPosition(){
    return `tdebug_pos_x_${this.position.colonne} tdebug_pos_y_${this.position.ligne} tdebug_declencheur_${this.state.codeDeplacement}`
  }

  changeCodeDeplacement(e:MouseEvent){
    console.log(e.nativeEvent);
    const indexCodeDep = CodeDeplacementListe.indexOf(this.state.codeDeplacement);
    var newCode;
    if (e.nativeEvent.altKey){
        newCode = (indexCodeDep === 0) ?
            CodeDeplacementListe[CodeDeplacementListe.length-1] : 
            CodeDeplacementListe[indexCodeDep-1];
    } else {
        newCode = (indexCodeDep > CodeDeplacementListe.length-2) ?
        CodeDeplacementListe[0] : 
        CodeDeplacementListe[indexCodeDep+1];
    }
    this.setState( {codeDeplacement:newCode as CodeDeplacement});
  }
  
  render() {    
    return (
        <div 
            className={clsx("tuileDebugDeclencheur", this.getClassPosition())}
            data-code={this.state.codeDeplacement}
            data-position={`${this.position.ligne}${this.position.colonne}`}   
            data-colonne={this.position.colonne}   
            data-ligne={this.position.ligne}   
            onClick={(e)=>{this.changeCodeDeplacement(e)}}         
        />
    )
  }
}

export default TuileDebugDeclencheur;
